<script setup lang="ts">
    import {
        Select,
        SelectContent,
        SelectGroup,
        SelectItem,
        SelectTrigger,
        SelectValue,
    } from '@/components/ui/select';

    const props = defineProps<{
        modelValue: string;
        options: { value: string; label: string }[];
    }>();

    const emit = defineEmits<{
        'update:modelValue': [value: string];
    }>();
</script>

<template>
    <Select
        :model-value="modelValue"
        @update:model-value="emit('update:modelValue', $event as string)"
    >
        <SelectTrigger>
            <SelectValue />
        </SelectTrigger>
        <SelectContent>
            <SelectGroup>
                <SelectItem
                    v-for="(option, index) in options"
                    :key="index"
                    :value="option.value"
                >
                    {{ $t(option.label) }}
                </SelectItem>
            </SelectGroup>
        </SelectContent>
    </Select>
</template>
